<script>

    export let label = ""
    export let value = ""
    export let prefix = ""
    export let posfix = ""
    export let link = null

</script>

<small><b>{ label }</b></small>

{#if link}
    <br>
    <a href={link} target="_blank">{ value }</a>
{:else}
    <div class="space-bottom">{ prefix }{ value }{ posfix }</div>
{/if}